module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Slider/assets/monetina-triste-034bc41d7ebae00bf6ca7974f1296c36.png";